export default __webpack_public_path__ + "img/cfd592f066d35b735e69a0bc1c693336.svg";